import { useEffect, useRef } from 'react';
export const useSortableGridResize = (width_current) => {
    const ref = useRef(null);
    useEffect(() => {
        if (ref.current && 'width' in ref.current.state && width_current) {
            ref.current.state.width = width_current + 6;
        }
        return () => {
            if (ref.current && 'width' in ref.current.state && width_current) {
                ref.current.state.width = width_current + 6;
            }
        };
    }, [width_current]);
    return ref;
};
